/* Tiger King premium effects (added 2026-08-05, Claude)
   Cursor-controlled spotlight + image parallax on the overlay banner
   cards, with a horizontal scroll parallax (cards drift in opposite
   directions).
   (Hero scroll-shrink effect removed at Tina's request 2026-08-05.)
   Everything respects prefers-reduced-motion and degrades to nothing. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Banner cursor reveal + horizontal parallax ---------- */
  var cards = [];
  var cardNodes = document.querySelectorAll('.banner-card');
  Array.prototype.forEach.call(cardNodes, function (card, i) {
    var img = card.querySelector('.banner-bg-image');
    if (!img) return;
    var state = { sx: 0, cx: 0, cy: 0 };
    img.style.willChange = 'transform';
    function apply() {
      img.style.transform =
        'translate3d(' + (state.sx + state.cx).toFixed(1) + 'px,' + state.cy.toFixed(1) + 'px,0) scale(1.12)';
    }
    apply();
    if (finePointer) {
      card.addEventListener('mousemove', function (ev) {
        var r = card.getBoundingClientRect();
        var x = ev.clientX - r.left;
        var y = ev.clientY - r.top;
        card.style.setProperty('--tk-mx', x + 'px');
        card.style.setProperty('--tk-my', y + 'px');
        state.cx = (x - r.width / 2) * 0.05;
        state.cy = (y - r.height / 2) * 0.05;
        apply();
      });
      card.addEventListener('mouseleave', function () {
        state.cx = 0;
        state.cy = 0;
        apply();
      });
    }
    cards.push({ el: card, state: state, apply: apply, dir: i % 2 === 0 ? 1 : -1 });
  });

  function bannerScroll() {
    if (!cards.length) return;
    var vh = window.innerHeight || 1;
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var r = c.el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) continue;
      var ratio = (r.top + r.height / 2 - vh / 2) / vh;
      c.state.sx = ratio * 48 * c.dir;
      c.apply();
    }
  }

  var ticking = false;
  function onFrame() {
    ticking = false;
    bannerScroll();
  }
  function requestTick() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(onFrame);
    }
  }
  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);
  window.addEventListener('load', requestTick);
  requestTick();
})();
